import {Modal} from "ui/base/modal/Modal";
import styled from "styled-components";
import {PillButton, PillButtonOutline, tokens} from "ui/blocks/guestMessaging/GuestUI";
import {mediaSizes} from "ui/theme";
import { LoaderComponent } from "ui/base/loading/LoaderComponent";
import {calculateRefundAmount} from "api/booking.api";
import {useEffect} from "react";
import {useQuery} from "@tanstack/react-query";

export const CancelClassModal = ({
                                     show,
                                     bookingId,
                                     role,
                                     handleClose,
                                     handleCancelClass,
                                 }) => {
    const {data, isLoading, refetch} = useQuery({
        queryKey: ["refundData", bookingId, role],
        queryFn: () =>
            calculateRefundAmount({
                booking_id: bookingId,
                type: role,
            }),
        enabled: false,
    });

    useEffect(() => {
        if (!show) return;
        refetch();
    }, [show, bookingId, role]);

    return (
        <Modal show={show} handleClose={handleClose} maxWidth={440} minHeight={0}>
            <Container>
                <Title>Cancel your class request?</Title>

                {isLoading ? (
                    <LoaderComponent minHeight="96px" />
                ) : (
                    <>
                        <Description>
                            Your request will be withdrawn. Payment will be refunded to your payment method.
                        </Description>
                        <ButtonContainer>
                            <PillButton type="button" onClick={handleClose}>
                                Keep request
                            </PillButton>
                            <DangerButton type="button" onClick={handleCancelClass}>
                                Cancel request
                            </DangerButton>
                        </ButtonContainer>
                    </>
                )}
            </Container>
        </Modal>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    font-family: var(--font-primary);
`;

const Title = styled.h2`
    margin: 0;
    padding-right: 40px; /* close button */
    font-size: 20px;
    font-weight: 600;
    line-height: 1.25;
    color: ${tokens.ink};
`;

const Description = styled.p`
    margin: 0;
    font-size: 15px;
    line-height: 1.5;
    color: ${tokens.muted};
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 12px;

    @media (width >= ${mediaSizes.md}) {
        flex-direction: row-reverse;

        & > * {
            flex: 1;
        }
    }
`;

/* Destructive, but secondary: outlined in red so it never reads as the default. */
const DangerButton = styled(PillButtonOutline)`
    border-color: ${tokens.error};
    color: ${tokens.error};

    &:hover:not(:disabled) {
        background: ${tokens.errorSoft};
    }
`;
